// import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import axios from 'axios';

// Define una interfaz que retorna directamente T en lugar de AxiosResponse<T>
// interface CustomAxiosInstance extends Omit<AxiosInstance, 'get' | 'post' | 'put' | 'patch' | 'delete'> {
//   get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
//   post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
//   put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
//   patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
//   delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
// }

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
});
//as CustomAxiosInstance;

apiClient.interceptors.response.use(
  (response) => {
    return response.data; 
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;

